import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ArchiveIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    {...props}
  >
    <Path d="M5.33335 6.66669H12M0.666687 0.666687H16.6667V3.33335H0.666687V0.666687ZM2.00002 3.33335H15.3334V15.3334H2.00002V3.33335Z" stroke={color} strokeWidth="1.33333" strokeLinejoin="round" />
  </Svg>
);

ArchiveIcon.displayName = 'ArchiveIcon';
